import { PrimaryButton } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { Trans } from "react-i18next";
import { array } from "yup";

import { AustralianNpcIdentificationDocumentsInputField } from "./AustralianNpcIdentificationDocumentsInputField";
import { AustralianNpcIdentificationDocumentsSummaryField } from "./AustralianNpcIdentificationDocumentsSummaryField";
import { IncompleteDocumentsModal } from "./IncompleteDocumentsModal";
import { getDocumentsPoints, isPrimaryDocumentUploaded } from "./utils";
import { FieldType } from "../types";

export function AustralianNpcIdentificationDocumentsField(
  field: components["schemas"]["AustralianNpcIdentificationDocumentsCheckField"]
): FieldType<
  components["schemas"]["AustralianNpcIdentificationDocumentsCheckField"]
> {
  return {
    field,
    inputElement: (
      <AustralianNpcIdentificationDocumentsInputField
        key={field.name}
        field={field}
      />
    ),
    summaryElement: () => (
      <AustralianNpcIdentificationDocumentsSummaryField
        key={field.name}
        field={field}
      />
    ),
    initialValue: field.value,
    schema: identifiationDocumentsSchema,
    saveButtonOverride: ({ values, submitFormWithoutValidation }) => {
      if (!isPrimaryDocumentUploaded(values[field.name])) {
        // returning undefined here would triggeer default Formik validation and show errors
        return undefined;
      }

      if (getDocumentsPoints(values[field.name]) < 100) {
        return (
          <IncompleteDocumentsModal
            key={field.name + "_presave_modal"}
            onNext={submitFormWithoutValidation}
            trigger={
              <PrimaryButton size="medium">
                <Trans>Next step</Trans>
              </PrimaryButton>
            }
          />
        );
      }

      return undefined;
    },
  };
}

export const identifiationDocumentsSchema = array()
  .test("Require primary document", "MISSING_PRIMARY_DOCUMENT", (values) =>
    isPrimaryDocumentUploaded(
      values as components["schemas"]["AustralianNpcIdentificationDocumentsCheckField"]["value"]
    )
  )
  .test(
    "Meet 100 point requirement",
    "MISSING_100_POINTS",
    (values) =>
      getDocumentsPoints(
        values as components["schemas"]["AustralianNpcIdentificationDocumentsCheckField"]["value"]
      ) >= 100
  );
